var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"media-kit-btn mb-12",on:{"click":function($event){$event.preventDefault();return _vm.goToMediaKit.apply(null, arguments)}}},[_c('span',{staticClass:"mr-2.5"},[_vm._v("See Full Media Kit")]),_c('MediaKitIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }